import { render, staticRenderFns } from "./EditRedirect.vue?vue&type=template&id=6d16d292&"
import script from "./EditRedirect.vue?vue&type=script&lang=js&"
export * from "./EditRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports